import Box from '@mui/material/Box'
import { RiAlertLine, RiCloseCircleLine } from '@/shared/icons/remix'

/** Dev Handoff 4418:9942 (negative), 4418:10043 (alert). */
export type ConfirmationIconVariant = 'alert' | 'negative'

const ICON_WELL: Record<
  ConfirmationIconVariant,
  { bgcolor: string; color: string; Icon: typeof RiAlertLine; size: number }
> = {
  negative: { bgcolor: '#fff0f0', color: '#ef4444', Icon: RiCloseCircleLine, size: 24 },
  alert: { bgcolor: '#fff0f0', color: '#ef4444', Icon: RiAlertLine, size: 31 },
}

type Props = Readonly<{
  variant: ConfirmationIconVariant
  testId?: string
}>

export function ConfirmationModalIcon({ variant, testId }: Props) {
  const { bgcolor, color, Icon, size } = ICON_WELL[variant]

  return (
    <Box
      data-testid={testId ?? `confirmation-icon-${variant}`}
      sx={{
        width: 64,
        height: 64,
        borderRadius: '50%',
        bgcolor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        color,
      }}
    >
      <Icon size={size} aria-hidden />
    </Box>
  )
}
